import { STATES } from 'helpers/Constants';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import BasicSelect from '@opploans/basic-select-component/BasicSelect';
import React from 'react';

const containerStyle = {
  display: 'flex',
  justifyContent: 'space-between'
};

function CityStateZip(props) {
  return (
    <div css={containerStyle}>
      <div css={{ width: '40%' }}>
        <BasicInput
          additionalProp={props.cityAdditionalProp}
          error={props.cityError}
          id={props.cityId}
          isVisible
          label='City'
          name='city'
          onBlur={props.cityOnBlur}
          onChange={props.cityOnChange}
          onMount={props.cityOnMount}
          onTouch={props.cityOnTouch}
          placeholder='City'
          presetDisabled={props.cityPresetDisabled}
          value={props.cityValue}
        />
      </div>

      <div css={{ width: '28%' }}>
        <BasicSelect
          defaultValue='State'
          error={props.stateError}
          id={props.stateId}
          isVisible
          name='state'
          label='State'
          onBlur={props.stateOnBlur}
          onChange={props.stateOnChange}
          options={props.states || STATES}
          presetDisabled={props.zipPresetDisabled}
          value={props.stateValue}
        />
      </div>

      <div css={{ width: '28%' }}>
        <BasicInput
          additionalProp={props.zipAdditionalProp}
          error={props.zipError}
          id={props.zipId}
          isNumeric
          maxLength={5}
          isVisible
          label='Zip'
          name='zip'
          onBlur={props.zipOnBlur}
          onChange={props.zipOnChange}
          onMount={props.zipOnMount}
          onTouch={props.zipOnTouch}
          placeholder='XXXXX'
          presetDisabled={props.zipPresetDisabled}
          value={props.zipValue}
        />
      </div>
    </div>
  );
}

export default CityStateZip;
